export class Accordion {
  constructor() {
    this._clickHandler = this._clickHandler.bind(this);
    this._ro = new ResizeObserver(() => this.update());
  }

  init() {
    document.addEventListener('click', this._clickHandler);

    document
      .querySelectorAll('[data-accordion="content"]')
      .forEach((el) => this._ro.observe(el));

    this.update();
  }

  _clickHandler(evt) {
    const btn = evt.target.closest('[data-accordion="button"]');
    if (!btn) return;

    evt.preventDefault();

    const element = btn.closest('[data-accordion="element"]');
    const parent = btn.closest('[data-accordion="parent"]');
    
    // Получаем content ДО проверки destroy
    const content = element?.querySelector('[data-accordion="content"]');

    if (parent?.dataset.destroy &&
    !window.matchMedia(parent.dataset.destroy).matches) {
    // Теперь content определен
    if (content) {
      content.style.removeProperty('max-height');
    }
    return;
  }

    if (element.classList.contains('is-active')) {
      this.close(element);
    } else {
      if (parent?.hasAttribute('data-single')) {
        parent
          .querySelectorAll('[data-accordion="element"].is-active')
          .forEach((el) => this.close(el));
      }
      this.open(element);
    }
  }

  update() {
    document.querySelectorAll('[data-accordion="element"]').forEach((el) => {
      const content = el.querySelector('[data-accordion="content"]');
      const parent = el.closest('[data-accordion="parent"]');
      if (!content) return;

      if (parent?.dataset.destroy &&
          !window.matchMedia(parent.dataset.destroy).matches) {
        content.style.maxHeight = '100%';
        return;
      }

      if (el.classList.contains('is-active')) {
        content.style.maxHeight = `${content.scrollHeight}px`;
      } else {
        content.style.maxHeight = '0';
      }
    });
  }

  open(element) {
    const content = element.querySelector('[data-accordion="content"]');
    if (!content) return;

    if (element.classList.contains('is-active')) return;

    element.classList.add('is-active');
    content.style.maxHeight = `${content.scrollHeight}px`;

    const parentElement = element.parentElement?.closest('[data-accordion="element"]');
    
    if (parentElement && parentElement !== element) {
      this.open(parentElement);
    }
  }

  close(element) {
    const content = element.querySelector('[data-accordion="content"]');
    if (!content) return;

    element.classList.remove('is-active');
    content.style.maxHeight = '0';
  }  
}